import { signal } from "@angular/core";
import { ButtonClass, ButtonType } from "@bitwarden/web-vault/app/models/types/button.types";

import { IButton } from "../../../models/interfaces/button.interface";

export abstract class Button implements IButton {
  isEnabled: boolean;
  /**
   * A submit button that was clicked and hasn't been re-enabled yet, i.e. its save is running.
   * A signal so the OnPush GlossButtonComponent re-renders (and drops aria-busy) when an owner
   * re-enables the button in place.
   */
  readonly submitting = signal(false);
  class: ButtonClass;
  fullClass: string;
  ghostDisabled: boolean;
  ghostShadow: boolean;
  testId: string;
  type: ButtonType;
  text: string;
  link: string;
  icon: string;
  iconClass: string;
  ariaLabel: string;
  onClick: () => void;

  constructor(properties: {
    type?: string;
    link?: string;
    onClick?: () => void;
    isEnabled?: boolean;
    icon?: string;
    iconClass?: string;
    class?: string;
    fullClass?: string;
    ghostDisabled?: boolean;
    ghostShadow?: boolean;
    text?: string;
    testId?: string;
    ariaLabel?: string;
  }) {
    this.class = (properties.class as ButtonClass) || "primary";
    this.type = (properties.type as ButtonType) || "none";
    this.link = properties.link || null;
    this.text = properties.text || "";
    this.icon = properties.icon || "";
    this.iconClass = properties.iconClass || "";
    this.isEnabled = properties.isEnabled ?? true;
    this.onClick = () => this.onButtonClicked(properties?.onClick);
    this.fullClass = properties.fullClass || "";
    this.ghostDisabled = properties.ghostDisabled ?? false;
    this.ghostShadow = properties.ghostShadow ?? false;
    this.testId = properties.testId;
    this.ariaLabel = properties.ariaLabel;
  }

  enableButton(value: boolean) {
    this.isEnabled = value;
    if (value) {
      this.submitting.set(false);
    }
  }

  onButtonClicked(onClick: () => void) {
    if (this.type === "submit") {
      this.enableButton(false);
      this.submitting.set(true);
    }

    if (onClick) {
      onClick();
    }
  }
}
